/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import { FaTimes } from 'react-icons/fa';
import useTranslation from '../../hooks/useTranslation';
import EpButton from '../EpButton';
import EpModal, { handleToggleModal } from '../EpModal';
import EpTable from '../EpTable';
import EpLocalLoading from '../EpLocalLoading';
import EpEmpty from '../EpEmpty';
import './styles.scss';

export default function EpErrorModal({
  tableData, columns, modalTitle, modalSubtitle, modalErrorCount, loading,
}) {
  // Tags do Globalization
  const Close = useTranslation('Close');
  const NoDataToDisplay = useTranslation('No data to display.');

  let bodyContent = (
    <div className="table__body-spinner">
      <EpLocalLoading />
    </div>
  );

  if (columns !== null && !loading) {
    if (tableData !== null && tableData !== undefined && tableData.itens !== null && tableData.itens.length > 0) {
      bodyContent = (
        <>
          <span className="error-modal__description">{modalSubtitle}: <span className="error-modal__description-result">{modalErrorCount}</span> </span>
          <div className="error-modal__table-wrapper">
            <EpTable
              tableData={tableData}
              columns={columns}
            />
          </div>
        </>
      );
    } else {
      bodyContent = (
        <EpEmpty
          title={NoDataToDisplay}
          noButton
        />
      );
    }
  }

  const headerTitle = (
    <span>{modalTitle}</span>
  );
  const footerContent = (
    <EpButton
      actionType="button"
      labelText={Close}
      linkFunc={() => handleToggleModal('modal--integrations-error')}
      buttonType="secondary-outline"
      buttonIcon={<FaTimes className="btn__icon" />}
      customClass="btn__footer"
      disabled={false}
    />
  );

  return (
    <EpModal
      modalId="modal--integrations-error"
      headerTitle={headerTitle}
      bodyContent={bodyContent}
      footerContent={footerContent}
      size="lg"
      alignFooter="justify-content-end"
    />
  );
}

EpErrorModal.defaultProps = {
  loading: false,
  tableData: null,
};

EpErrorModal.propTypes = {
  tableData: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.object),
  ])),
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  modalTitle: PropTypes.string.isRequired,
  modalSubtitle: PropTypes.string.isRequired,
  modalErrorCount: PropTypes.number.isRequired,
  loading: PropTypes.bool,
};
